;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .controller('EditRuleManageCtrl', EditRuleManageCtrl)

  function EditRuleManageCtrl(
    $scope,
    $timeout,
    $routeParams,
    $uibModal,
    $translate,
    UserService,
    RulesService,
    RuleFactory,
    PromiseService,
    LoadFilterRouteService,
    SERVER_ENVIRONMENT,
    AGENT_FEATURE,
    FeaturesService,
    ErrorService
  ) {
    'ngInject'

    var _searchKeywords = ''
    var numPerLoaded = 15
    var lastSearch = {}
    var ruleName = $routeParams.ruleName
    var rule = {}

    angular.extend($scope, {
      selectedApps: [],
      quickFilters: [],
      selectedQuickFilter: {
        name: $translate.instant('title_all_applications'),
        filterType: 'ALL',
        count: '?'
      },
      appPromise: undefined,

      searchKeywords: searchKeywords,

      model: {
        busy: false,
        selectAllCheckbox: false,
        row: 'appName',
        total: undefined,
        updating: false
      },
      data: {
        title: '',
        description: '',
        severity: '',
        severityLabel: '',
        apps: []
      }
    })

    // API
    angular.extend($scope, {
      openSettings: openSettings,
      openChangeModeModal: openChangeModeModal,
      toggleSelection: toggleSelection,
      onSelectAll: onSelectAll,
      order: order,
      quickFilterSelect: quickFilterSelect,
      loadByScroll: loadByScroll,
      moveToServer: moveToServer,
      changeStatus: changeStatus,
      hasAppPermission: hasAppPermission
    })

    function init() {
      rule.rule_name = ruleName

      if (UserService.isFreemiumOrganization()) {
        $scope.selectedQuickFilter = {
          name: 'JAVA',
          filterType: 'JAVA',
          count: '?'
        }
      }

      _loadFilters().then(function () {
        _loadApps(0, numPerLoaded)
      })
    }

    function openSettings() {
      $uibModal.open({
        templateUrl: 'views/rules/manage/rule_settings_modal.html',
        controller: 'RulesSettingsModalCtrl',
        size: 'lg-md',
        resolve: {
          ruleName: function () {
            return $routeParams.ruleName
          }
        }
      })
    }

    function _loadFilters() {
      return RulesService.getDrilldownQuickFilters(ruleName, _searchKeywords)
        .then(function (response) {
          $scope.quickFilters = response

          $scope.selectedQuickFilter = $scope.quickFilters.find(function (
            filter
          ) {
            return filter.filterType === $scope.selectedQuickFilter.filterType
          })

          $scope.model.total = $scope.selectedQuickFilter.count
        })
        .catch(ErrorService.processError)
    }

    function _loadApps(offset, limit) {
      if ($scope.appPromise) {
        PromiseService.cancelPromise($scope.appPromise)
      }

      $scope.data.busy = true

      var params = {
        quickFilter: $scope.selectedQuickFilter.filterType,
        filterText: _searchKeywords,
        limit: limit,
        offset: offset,
        sort: $scope.model.row,
        expand: 'roles'
      }

      lastSearch = RuleFactory.getApplicationsPolicyByRule(ruleName, params)

      lastSearch
        .then(function (response) {
          $scope.data.busy = false
          $scope.data.title = response.data.title
          $scope.data.description = response.data.description
          $scope.data.severity = response.data.severity
          $scope.data.severityLabel = response.data.severityLabel
          $scope.data.languages = response.data.languages
          $scope.data.isInAllLanguages =
            FeaturesService.isFeatureInAllLanguages(
              AGENT_FEATURE.ASSESS,
              response.data.languages
            )

          if ($scope.model.selectAllCheckbox) {
            angular.forEach(response.data.configs, function (app) {
              if (hasAppPermission(app.app, 'RULES_ADMIN')) {
                app.selected = true
                $scope.selectedApps.push(app)
              }
            })
          }

          $scope.data.apps = $scope.data.apps.concat(response.data.configs)

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })
        })
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.data.busy = false
          $scope.model.updating = false
        })

      $scope.appPromise = lastSearch
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      $scope.selectedApps = []
      $scope.data.apps = []

      _loadFilters().then(function () {
        _loadApps(0, numPerLoaded)
      })
      return _searchKeywords
    }

    function openChangeModeModal() {
      $uibModal
        .open({
          templateUrl: 'views/applications/settings/assess_modal.html',
          controller: 'ModalAssessRuleModalCtrl',
          size: 'md-sm',
          resolve: {
            appIds: function () {
              return _.map(_.map($scope.selectedApps, 'app'), 'app_id')
            },
            ruleId: function () {
              return ruleName
            },
            callback: function () {
              return resetApps
            },
            quickFilter: function () {
              return $scope.selectedQuickFilter.filterType
            },
            filterText: function () {
              return _searchKeywords
            },
            allRulesSelected: function () {
              return $scope.model.selectAllCheckbox
            }
          }
        })
        .result.then(resetApps)
    }

    function onSelectAll() {
      if ($scope.model.selectAllCheckbox) {
        _selectAll()
      } else {
        _deselectAll()
      }
    }

    function _selectAll() {
      $scope.selectedApps = []
      angular.forEach($scope.data.apps, function (app) {
        if (hasAppPermission(app.app, 'RULES_ADMIN')) {
          app.selected = true
          $scope.selectedApps.push(app)
        }
      })

      return $scope.selectedApps
    }

    function _deselectAll() {
      $scope.selectedApps = []
      angular.forEach($scope.data.apps, function (app) {
        app.selected = false
      })

      return $scope.selectedApps
    }

    function toggleSelection(app) {
      var idx = $scope.selectedApps.indexOf(app)

      if (idx > -1) {
        $scope.selectedApps.splice(idx, 1)
      } else {
        $scope.selectedApps.push(app)
      }

      $scope.model.selectAllCheckbox =
        $scope.selectedApps.length === $scope.model.total

      return $scope.selectedApps
    }

    function order(rowName) {
      if ($scope.data.row === rowName) {
        return
      }

      $scope.model.row = rowName
      resetApps()
    }

    function quickFilterSelect(filter) {
      $scope.selectedApps = []
      $scope.data.apps = []
      $scope.model.selectAllCheckbox = false

      $scope.selectedQuickFilter = filter
      $scope.model.total = $scope.selectedQuickFilter.count

      resetApps()
    }

    function loadByScroll() {
      $scope.model.busy = true
      if ($scope.data.apps.length < $scope.model.total) {
        _loadApps($scope.data.apps.length, numPerLoaded)
      }
    }

    function moveToServer(appId, env) {
      LoadFilterRouteService.goToServersFilteredByApp(appId, env)
    }

    function resetApps() {
      $scope.selectedApps = []
      $scope.data.apps = []
      _loadApps(0, numPerLoaded)
    }

    function changeStatus(appId, enabled, environment) {
      $scope.model.updating = true
      RulesService.updateStatusByApplication(appId, rule, enabled, environment)
        .then(
          _updateRuleEnabled.bind({
            appId: appId,
            enabled: enabled,
            environment: environment
          })
        )
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.model.updating = false
        })
    }

    // Update the matching rule inside $scope.data.apps
    function _updateRuleEnabled() {
      var apps = $scope.data.apps,
        i = 0,
        len = apps.length,
        app
      for (; i < len; i++) {
        app = apps[i]
        if (app.app_id == this.appId) {
          if (this.environment === SERVER_ENVIRONMENT.DEVELOPMENT.value) {
            app.dev_enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.QA.value) {
            app.qa_enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.PRODUCTION.value) {
            app.prod_enabled = this.enabled
          }
          return
        }
      }
    }

    function hasAppPermission(application, permission) {
      permission = 'ROLE_' + permission.trim()

      var roles = application.roles

      return _.some(roles, function (item) {
        if (_.isString(item)) {
          return item.trim() === permission
        }
      })
    }

    init()
  }
})()
